import { ButtonLink } from '@designsforhealth/dfh-react-components'
import styled from 'styled-components'
import StyledModal from 'styled-react-modal'

import CloseIconSvg from '../../../../../../../img/close.inline.svg'

export const Modal = StyledModal.styled`
  width: 95%;
  max-width: 874px;
  max-height: 90%;
  display: flex;
  flex-direction: column;
  background-color: white;
  position: relative;
  border-radius: 8px;
  overflow: auto;
  @media print {
    height: auto;
  }
`

export const Content = styled.div`
  width: 100%;
  overflow-y: auto;
  border-radius: 8px;
  min-width: 600px;
  @media (min-width: 768px) {
    display: flex;
    flex-direction: column;
  }
`

export const CloseModalButtonLink = styled(ButtonLink)`
  display: block;
  background: none;
  margin: 0;
  padding: 0;
  border: 0;
  position: absolute;
  right: 10px;
  top: 10px;
  z-index: 1;
`

export const CloseIcon = styled(CloseIconSvg)`
  width: 16px;
  height: 16px;
`
